// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"5bab262f","80":"7ca8952e","123":"34e794c3","829":"6da7f9b4"}[chunkId] + ".css";
};